// Styles
import 'reset-css';
import "./index.scss";

// Scripts
import "./scripts/scripts.js";
import "./template/layout/layout.js";
import "./template/components/components.js";
